"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "sagliano-micca": {
    "b78c8d12": [{
      "hkey": "f7ecc13c",
      "slug": "code",
      "name": "Code",
      "primary": true,
      "skipSearch": false
    }],
    "case-code-inferiore": [{
      "hkey": "f7ecc13c",
      "slug": "code",
      "name": "Code",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "0a9a00ff": [{
      "hkey": "f7ecc13c",
      "slug": "code",
      "name": "Code",
      "primary": true,
      "skipSearch": false
    }],
    "case-code-superiore": [{
      "hkey": "f7ecc13c",
      "slug": "code",
      "name": "Code",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "sagliano-micca"
    }],
    "5c05951e": [{
      "hkey": "ddf275c4",
      "slug": "centro-casale-passobreve",
      "name": "Centro-Casale-Passobreve",
      "primary": true,
      "skipSearch": false
    }],
    "passobreve": [{
      "hkey": "ddf275c4",
      "slug": "centro-casale-passobreve",
      "name": "Centro-Casale-Passobreve",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "sagliano-micca"
    }],
    "6bc8d25c": [{
      "hkey": "8aef9018",
      "slug": "sagliano-micca",
      "name": "Sagliano Micca",
      "primary": true,
      "skipSearch": false
    }],
    "regione-bazzerra": [{
      "hkey": "8aef9018",
      "slug": "sagliano-micca",
      "name": "Sagliano Micca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2297def3": [{
      "hkey": "8aef9018",
      "slug": "sagliano-micca",
      "name": "Sagliano Micca",
      "primary": true,
      "skipSearch": false
    }],
    "regione-la-polla": [{
      "hkey": "8aef9018",
      "slug": "sagliano-micca",
      "name": "Sagliano Micca",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2609d2c0": [{
      "hkey": "ddf275c4",
      "slug": "centro-casale-passobreve",
      "name": "Centro-Casale-Passobreve",
      "primary": true,
      "skipSearch": false
    }],
    "rione-casale": [{
      "hkey": "ddf275c4",
      "slug": "centro-casale-passobreve",
      "name": "Centro-Casale-Passobreve",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "sagliano-micca"
    }]
  }
};
exports["default"] = _default;